import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { ReivewInfoTable } from "components/review/detail";
import { OneBtnModal, TwoBtnModal } from "components/common/modal";
import { AddBtn, PrimaryBtn } from "components/common/button";
import {
  getReviewDetail,
  postReview,
  putReview,
  delReview,
} from "service/api/review";
import responseCodeConstant from "service/constant/responseCodeConstant";
import type { IReviewDetail } from "service/interface/review";
import routerConstant from "service/constant/routerConstant";
import moment from "moment";

export function ReviewDetailPage() {
  const params = useParams();
  const navigate = useNavigate();
  const [detailData, setDetailData] = useState<IReviewDetail>(
    {} as IReviewDetail,
  );
  const [isSaveSuccessmodalVisible, setIsSaveSuccessModalVisible] =
    useState<boolean>(false);
  const [isDeleteModalVisible, setIsDeleteModalVisible] =
    useState<boolean>(false);
  const [isDeleteSuccessModalVisible, setIsDeleteSuccessModalVisible] =
    useState<boolean>(false);

  useEffect(() => {
    if (params.id) {
      if (params.id === "add") {
      } else {
        (async () => {
          const detailRes = await getReviewDetail(params.id + "");
          if (detailRes.status === responseCodeConstant.SUCCESS.ok) {
            setDetailData({
              ...detailRes.data.data,
              reviewedAt: moment(detailRes.data?.data?.reviewedAt).format(
                "YYYY-MM-DD",
              ),
            });
          }
        })();
      }
    }
  }, [params]);

  const handleAddBtn = async () => {
    const addRes = await postReview({
      title: detailData.title,
      writer: detailData.writer,
      reviewedAt: detailData.reviewedAt,
      score: detailData.score,
      category: detailData.category,
      content: detailData.content,
    });
    if (addRes.status === responseCodeConstant.SUCCESS.ok) {
      setIsSaveSuccessModalVisible(true);
    }
  };

  const handleSaveBtn = async () => {
    const saveRes = await putReview({
      reviewId: params.id + "",
      body: {
        title: detailData.title,
        writer: detailData.writer,
        reviewedAt: detailData.reviewedAt,
        score: detailData.score,
        category: detailData.category,
        content: detailData.content,
      },
    });
    if (saveRes.status === responseCodeConstant.SUCCESS.ok) {
      setIsSaveSuccessModalVisible(true);
    }
  };

  const handleDeleteBtn = () => {
    setIsDeleteModalVisible(true);
  };

  const handleDeleteModalBtn = async () => {
    const delRes = await delReview(params.id + "");
    if (delRes.status === responseCodeConstant.SUCCESS.ok) {
      setIsDeleteSuccessModalVisible(true);
    }
  };

  const handleSuccessModalBtn = () => {
    navigate(routerConstant.REVIEW.list);
  };

  return (
    <>
      <OneBtnModal
        isVisible={isSaveSuccessmodalVisible}
        setIsVisible={setIsSaveSuccessModalVisible}
        title={params.id === "add" ? "추가 완료" : "등록 완료"}
        subTitle="저장이 완료되었습니다"
        btnLabel="확인"
        btnClick={handleSuccessModalBtn}
      />
      <OneBtnModal
        isVisible={isDeleteSuccessModalVisible}
        setIsVisible={setIsDeleteSuccessModalVisible}
        title="삭제 완료"
        subTitle="삭제가 완료되었습니다"
        btnLabel="확인"
        btnClick={handleSuccessModalBtn}
      />
      <TwoBtnModal
        isVisible={isDeleteModalVisible}
        setIsVisible={setIsDeleteModalVisible}
        title="해당 리뷰를 삭제하시겠습니까?"
        subTitle=""
        btnLabel="삭제하기"
        btnClick={handleDeleteModalBtn}
      />
      <div className="h-full min-h-[100vh] w-[calc(100%-273px)] bg-[#fdfdfd]">
        <div className="mx-auto w-[1167px] p-[78px_80px_72px_64px]">
          <p className="m-0 mb-[8px] text-[16px] font-semibold leading-[20px] text-gray-4 opacity-[0.5]">
            메모리올 관리자 화면
          </p>
          <div className="flex items-center justify-between">
            <p className="m-0 text-[32px] font-medium leading-[40px] text-black">
              리뷰 관리
            </p>
            {params.id !== "add" && (
              <AddBtn isRemove onClick={handleDeleteBtn} />
            )}
          </div>
          <div className="mt-[32px] flex flex-col rounded-[12px] bg-white p-[48px_40px_64px_48px] shadow-[0px_0px_8px_rgba(0,0,0,0.1)]">
            <ReivewInfoTable data={detailData} setData={setDetailData} />
            <div className="mt-[24px] flex justify-end">
              <PrimaryBtn
                label={params.id === "add" ? "등록하기" : "수정하기"}
                isDisabled={
                  !detailData.category ||
                  !detailData.content ||
                  !detailData.score ||
                  !detailData.title ||
                  !detailData.writer ||
                  !detailData.reviewedAt
                }
                onClick={params.id === "add" ? handleAddBtn : handleSaveBtn}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
